var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u201C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-760.000000, -1911.000000)",
    fill: "#86D053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Success-Story",
    transform: "translate(27.000000, 1667.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37-Copy",
    transform: "translate(47.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2518191,10.6763592 C17.6697731,11.9462179 16.3787695,13.4382795 16.3787695,15.1525887 C17.4793137,15.2795746 18.3893654,15.7293095 19.108952,16.5018068 C19.8285386,17.2743042 20.1883265,18.1684829 20.1883265,19.1843699 C20.1883265,20.2637498 19.8391206,21.1738015 19.1406983,21.9145524 C18.4422761,22.6553033 17.5639703,23.0256732 16.5057547,23.0256732 C15.3205533,23.0256732 14.2940996,22.5441924 13.4263628,21.5812162 C12.558626,20.61824 12.1247642,19.4489293 12.1247642,18.0732491 C12.1247642,13.9462084 14.4316395,10.7186993 19.0454594,8.390625 L20.2518191,10.6763592 Z M8.63267022,10.6763592 C6.0294599,11.9462179 4.72787427,13.4382795 4.72787427,15.1525887 C5.84958278,15.2795746 6.77021652,15.7293095 7.48980311,16.5018068 C8.2093897,17.2743042 8.5691776,18.1684829 8.5691776,19.1843699 C8.5691776,20.2637498 8.2146807,21.1738015 7.50567626,21.9145524 C6.79667183,22.6553033 5.91307508,23.0256732 4.8548595,23.0256732 C3.66965806,23.0256732 2.64849535,22.5441924 1.79134073,21.5812162 C0.934186114,20.61824 0.505615234,19.4489293 0.505615234,18.0732491 C0.505615234,13.9462084 2.80190859,10.7186993 7.39456418,8.390625 L8.63267022,10.6763592 Z",
    id: "\\u201C"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteHs);
export default __webpack_public_path__ + "static/media/quoteHS.7fbb1963c82419121c86cddd81740b30.svg";
export { ForwardRef as ReactComponent };